"use client";

import { Navbar, Dropdown, Avatar, Badge } from "flowbite-react";
import { Link } from "react-router-dom";
import { MdDashboard } from "react-icons/md";





const Header = () => {
  return (
    <Navbar fluid rounded className="mb-3 border-b-2 py-1 pb-0 header">
      <div className="flex">
        <Link className="me-3 p-2 border-2 rounded hover:text-blue-500" to={'/'}>{<MdDashboard />}</Link>
        <Navbar.Brand as={Link} to={'/sales/'} className="w-50">
          <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">Sales</span>
        </Navbar.Brand>
      </div>
      <div className="flex">

        <Dropdown arrowIcon={false} inline label={<span className="mx-2">Orders</span>}>
          <Dropdown.Item as={Link} to={'/sales/quotation'}>Quotations</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/sales/orders'}>Sales Orders</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/sales/teams/dashboard'}>Sales Teams</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/sales/customers'}>Customers</Dropdown.Item>
        </Dropdown>


        <Dropdown arrowIcon={false} inline label={<span className="mx-2">To Invoice</span>}>
          <Dropdown.Item as={Link} to={'/sales/to-invoice'}>Orders To Invoice</Dropdown.Item>
          {/* <Dropdown.Item as={Link} to={'/sales/packages'}>Product Variants</Dropdown.Item> */}
        </Dropdown>

        <Dropdown arrowIcon={false} inline label={<span className="mx-2">Products</span>}>
          <Dropdown.Item as={Link} to={'/sales/products'}>Products</Dropdown.Item>
          {/* <Dropdown.Item as={Link} to={'/sales/packages'}>Product Variants</Dropdown.Item> */}
        </Dropdown>

        <Dropdown arrowIcon={false} inline label={<span className="mx-2">Reporting</span>}>
          <Dropdown.Item as={Link} to={'/sales/report/sales'}>Sales</Dropdown.Item>
        </Dropdown>

        <Dropdown arrowIcon={false} inline label={<span className="mx-2">Configurations</span>}>
          <Dropdown.Item>Settings</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/sales/teams'}>Sales Team</Dropdown.Item>
          <Badge className="text-slate-600 bg-transparent">Sales Orders</Badge>
          <Dropdown.Item as={Link} to={'/sales/tags'}>Tags</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/sales/shipping-method'}>Shipping Methods</Dropdown.Item>
          <Badge className="text-slate-600 bg-transparent">Products</Badge>
          <Dropdown.Item as={Link} to={'/sales/attributes'}>Product Attributes</Dropdown.Item>
          {/* <Dropdown.Item as={Link} to={'/sales/product-categories'}>Product Categories</Dropdown.Item> */}

        </Dropdown>
      </div>
      <div className="">
        
        <Dropdown
          arrowIcon={false}
          inline
          label={
            <Avatar alt="User settings" img="https://flowbite.com/docs/images/people/profile-picture-5.jpg" rounded />
          }
        >
          <Dropdown.Header>
            <span className="block text-sm">Bonnie Green</span>
            <span className="block truncate text-sm font-medium">name@flowbite.com</span>
          </Dropdown.Header>
          <Dropdown.Item>Dashboard</Dropdown.Item>
          <Dropdown.Item>Settings</Dropdown.Item>
          <Dropdown.Item>Earnings</Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item>Sign out</Dropdown.Item>
        </Dropdown>
        {/* <Navbar.Toggle /> */}
      </div>
      {/* <Navbar.Collapse>
        <Navbar.Link href="#" active>
          Home
        </Navbar.Link>
        <Navbar.Link href="#">About</Navbar.Link>
        <Navbar.Link href="#">Services</Navbar.Link>
        <Navbar.Link href="#">Pricing</Navbar.Link>
        <Navbar.Link href="#">Contact</Navbar.Link>
      </Navbar.Collapse> */}
    </Navbar>
  );
}




export default Header;